import PropTypes from 'prop-types';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import Button from '@mui/material/Button';
import { styled } from '@mui/material';
import Colors from 'constants/colors';

const StyledButton = styled(Button)({
    fontWeight: 500,
    width: 100,
    height: 38
});

function RpClearFiltersModal(props) {
    return (
        <Dialog
            open={props.open}
            onClose={props.onClose}
            data-testid="filter-actions-dialog"
        >
            <DialogTitle>Are you sure you want to clear all filters for this search?</DialogTitle>
            <DialogContent
                sx={{
                    fontSize: 16,
                    color: Colors.BLACK_60_OPAQUE,
                }}
            >
                This will remove the applied filters and cannot be undone.
            </DialogContent>
            <DialogActions sx={{ p: 3 }} >
                <StyledButton onClick={props.onClose} color="tertiary">
                    {props.cancelText || 'Cancel'}
                </StyledButton>
                <StyledButton onClick={props.onConfirm} color="error" variant="outlined">
                    {props.confirmText || 'Clear all'}
                </StyledButton>
            </DialogActions>
        </Dialog>
    );
}

RpClearFiltersModal.propTypes = {
    open: PropTypes.bool.isRequired,
    onClose: PropTypes.func.isRequired,
    onConfirm: PropTypes.func.isRequired,
    cancelText: PropTypes.string,
    confirmText: PropTypes.string,
};

export default RpClearFiltersModal;
